import { render, staticRenderFns } from "./DetailContactsPerPost.vue?vue&type=template&id=e91b029a&"
import script from "./DetailContactsPerPost.vue?vue&type=script&lang=js&"
export * from "./DetailContactsPerPost.vue?vue&type=script&lang=js&"
import style0 from "./DetailContactsPerPost.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DetailContactsPerPost.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports